(ns rlws.iot-cloud.frontend.assets.logic
  (:require [rlws.iot-cloud.frontend.site :as site]
            [rlws.iot-cloud.frontend.data :as data]))

(defn asset-status [asset live-assets]
  (let [{:keys [cells scale number asset-id] :as status} (get live-assets (site/to-plain-id asset))] 
    (cond
      (not-empty scale)
      (conj (first (mapv (comp data/diagnostics keyword) scale)) {:number number, :asset-id asset-id})
      (not-empty cells)
      (conj (first (mapv (comp data/diagnostics keyword :capability) cells)) {:number number, :asset-id asset-id})
      status
      {:title "Clear"
       :state :ok
       :number number
       :asset-id asset-id}
      :else
      {:title "Disconnected"
       :state :disconnected
       :number number
       :asset-id asset-id})))

(defn asset-status-by-id
  [status]
  (let [scale (:scale status)
        cells (:cells status)
        number (:number status)
        asset-id (:asset-id status)]
  (cond
    (not-empty scale)
    (conj (first (mapv (comp data/diagnostics keyword) scale)) {:number number, :asset-id asset-id})
    (not-empty cells)
    (conj (first (mapv (comp data/diagnostics keyword :capability) cells)) {:number number, :asset-id asset-id})
    status
    {:title "Clear"
     :state :ok
     :number number
     :asset-id asset-id}
    :else
    {:title "Disconnected"
     :state :disconnected
     :number number
     :asset-id asset-id})))
